import { p as palette, c as color } from '../base/color-DMp1DFwP.js';
import { t as typography, l as link } from '../base/typography-Bqsizo4g.js';
import { a as spacingValues, s as spacing } from '../base/spacing-zNVNrnl_.js';
import { f as focus } from '../base/focus-B_eJw-S_.js';
import { g as globals } from '../base/globals-CU3Khanb.js';
import { a as alert } from '../component/alert-oVc34hsZ.js';
import { b as breadcrumbs } from '../component/breadcrumb-CqtUb2OV.js';
import { b as button } from '../component/button-D3PzMCCP.js';
import { c as card } from '../component/card-ceWzsoof.js';
import { c as checkboxStyles } from '../component/checkbox-CDMBZpqc.js';
import { c as circularProgressIndicatorStyles } from '../component/circularProgressIndicator-LIWa-dLk.js';
import { d as datepicker } from '../component/datepicker-C_ggBuG-.js';
import { d as dividerStyles } from '../component/divider-BcpVpxf1.js';
import { d as dropdownStyles } from '../component/dropdown-BJyckgNF.js';
import { h as helptipStyles } from '../component/helptip-Kff28dZX.js';
import { i as icon } from '../component/icon-DQ43FXA3.js';
import { i as inputStyles } from '../component/input-Cl-7lCgO.js';
import { l as labelStyles } from '../component/label-DinWA6zZ.js';
import { m as modal } from '../component/modal-CBoDhKd7.js';
import { p as pagination } from '../component/pagination-Bf5FM4AC.js';
import { p as pill } from '../component/pillLegacy-BI5qf2Xj.js';
import { p as pill$1 } from '../component/pill-DASN-U6P.js';
import { p as popover } from '../component/popover-CbE5lSgB.js';
import { p as portalStyles } from '../component/portal-DhH1e5-Z.js';
import { p as progressIndicatorStyles } from '../component/progressIndicator-D6c5ZRgP.js';
import { r as radioStyles } from '../component/radio-CA_JW5tk.js';
import { r as rangeSlider } from '../component/rangeSlider-CDtxWXr-.js';
import { s as sectionExpanderStyles } from '../component/sectionExpander-DstHvirw.js';
import { s as sideNavStyles, a as sideNavItemStyles } from '../component/sideNavigation-BbRESjt3.js';
import { s as searchInputStyles } from '../component/searchInput-Dl_O8Ajp.js';
import { s as snackbar } from '../component/snackbar-BMox7zKO.js';
import { s as sortableListStyles } from '../component/sortableList-vCIwfpds.js';
import { s as starRatingStyles } from '../component/starRating-CbkgZbUO.js';
import { s as stepsStyles } from '../component/steps-CWTC1UV-.js';
import { s as surfaceStyles } from '../component/surface-CjDqA5Xg.js';
import { s as switchStyles } from '../component/switch-ClnqNU3i.js';
import { t as tableStyles } from '../component/table-DbZWDbh4.js';
import { t as tabNavigationStyles } from '../component/tabNavigation-B_e5GmWH.js';
import { t as tagStyles } from '../component/tag-DGCCh_ry.js';
import { t as textAreaStyles } from '../component/textarea-CNkfng2a.js';
import { t as tooltip } from '../component/tooltip-BTnjpaiq.js';
import { t as touchLink } from '../component/touchLink-BOSmu3eY.js';
import { t as tree } from '../component/tree-BeeBH0oq.js';
import { t as treeViewStyles } from '../component/treeView-DXFpY_pF.js';
import { a as anchoredAlertStyles } from '../component/anchoredAlert-CUi7Yfgi.js';
import { s as secondaryView } from '../component/secondaryView-Dmb5CGIK.js';
import { s as splitButton } from '../component/splitButton-pw-eLS1y.js';
import { p as peekabooStickyTab } from '../component/peekabooStickyTab-Dmoxx5Ky.js';
import { p as pageLayout } from '../component/pageLayout-CjtHtK76.js';
import { s as surfaceDarkStyles } from '../component/surfaceDark-CjzXgz54.js';
import { s as surfaceDarkInfoStyles } from '../component/surfaceDarkInfo-nak4bJe3.js';
import { s as surfaceLightStyles } from '../component/surfaceLight-DG2QX_Dm.js';

const theme = {
  pageLayout,
  palette,
  spacingValues,
  spacing,
  globals,
  color,
  typography,
  breadcrumbs,
  button: button,
  card,
  divider: dividerStyles,
  dropdown: dropdownStyles,
  form: {
    label: labelStyles,
    input: inputStyles,
    textarea: textAreaStyles,
    search: searchInputStyles,
    checkbox: checkboxStyles,
    radio: radioStyles
  },
  icon,
  message: alert,
  modal,
  navigation: {
    tabs: tabNavigationStyles
  },
  pagination: pagination,
  pillLegacy: pill,
  pillv2Beta: pill$1,
  // adding in for TropicalUI support, which references this theme value
  pill: pill$1,
  popover: popover,
  portal: portalStyles,
  switch: switchStyles,
  tooltip,
  helptip: helptipStyles,
  datepicker,
  starRating: starRatingStyles,
  sortableList: sortableListStyles,
  sideNav: sideNavStyles,
  sideNavItem: sideNavItemStyles,
  surface: surfaceStyles,
  surfaceLight: surfaceLightStyles,
  surfaceDark: surfaceDarkStyles,
  surfaceDarkInfo: surfaceDarkInfoStyles,
  rangeSlider,
  table: tableStyles,
  tree,
  treeView: treeViewStyles,
  sectionExpander: sectionExpanderStyles,
  tag: tagStyles,
  touchLink,
  steps: stepsStyles,
  focusVisible: focus,
  progressIndicator: progressIndicatorStyles,
  circularProgressIndicator: circularProgressIndicatorStyles,
  snackbar,
  anchoredAlert: anchoredAlertStyles,
  link,
  secondaryView,
  splitButton,
  peekabooStickyTab
};

export { theme as t };
//# sourceMappingURL=default-BrkF3upi.js.map
